import React from 'react';
import Button from 'components/ContentfulFields/Button';
import MapIcon from './MapIcon';
import styles from './styles.scss';

const URL = 'https://www.water.com/';

const FindWater = () => (
  <article className={styles.findWater}>
    <figure>
      <MapIcon />
    </figure>
    <div className={styles.text}>
      <h2>Find water near me</h2>
      <p>
        Primo Water offers Pre-Filled Exchange Water and Self-Service Refill
        Water to get great-tasting water for you and your family on your terms.
      </p>
    </div>
    <div className={styles.cta}>
      <Button to={URL} text="Find Water" className={styles.btn} />
    </div>
  </article>
);

export default FindWater;
